import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_image_svg = _resolveComponent("base-image-svg")!
  const _component_lyra_asset = _resolveComponent("lyra-asset")!
  const _component_pfizer_footer_categories = _resolveComponent("pfizer-footer-categories")!

  return (_openBlock(), _createBlock(_component_pfizer_footer_categories, { class: "hd-c-hub-gallery-footer" }, {
    anchor: _withCtx(() => [
      _createElementVNode("div", {
        class: "hd-footer-link hd-c-hub-gallery-footer__anchor",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateHome && _ctx.navigateHome(...args)))
      }, [
        _createVNode(_component_base_image_svg, {
          colour: "white",
          source: require('!html-loader!../assets/images/home-icon.svg')
        }, null, 8, ["source"]),
        _createVNode(_component_lyra_asset, { "asset-key": "bottom-nav-home" })
      ])
    ]),
    _: 1
  }))
}